import { reducer as reportsReducer } from './model/reports';

export * as ReportsModel from './model';

export default reportsReducer;
